import { Box, IconButton } from '@mui/material';
import { ArrowLeftIcon } from '@silbo/ui';

type BackButtonProps = {
  onClick: () => void;
};

const BackButton = ({ onClick }: BackButtonProps) => {
  return (
    <Box position="absolute" left={24} top={24} zIndex={1}>
      <IconButton variant="filled" color="primary" onClick={onClick}>
        <ArrowLeftIcon />
      </IconButton>
    </Box>
  );
};

export default BackButton;
